import { defineProductDimensions, mutaPricingVersionDimension, mutaSelectedDimension } from '@orus.eu/dimensions'

import { mutaProductVersionDimension } from './muta-dimensions.ts'
import { mutaQuoteDimension } from './muta-quote-dimension.ts'

export * from './guarantees/index.ts'
export * from './muta-beneficiary-dimension.ts'
export * from './muta-dimensions.ts'
export * from './muta-formula-dimension.ts'
export * from './muta-guarantee.ts'
export * from './muta-guarantees-dimension.ts'
export * from './muta-product-information.ts'
export * from './muta-quote-dimension.ts'
export * from './muta-subscription-ui.ts'
export * from './muta-ui-elements.ts'

export const mutaDimensionsModule = defineProductDimensions({
  product: 'muta',
  family: null,
  selectionDimension: mutaSelectedDimension,
  productVersionDimension: mutaProductVersionDimension,
  pricingVersionDimension: mutaPricingVersionDimension,
  quoteV2Dimension: mutaQuoteDimension,
})
